import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import Scrollbars from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "./sidebardata";
import Chatbot from '../Bot/Chatbot';
import { ChevronLeft, Grid, Layers, Bookmark, RefreshCw, Calendar, Clock, Activity, Sun, DollarSign, Camera, MapPin, Box, Briefcase, Bell, FileText, Award, TrendingUp, FileMinus, FilePlus, List, Settings, Clipboard, Home } from 'react-feather';
import { FaUsers, FaBriefcase, FaCalendarAlt, FaPlaneArrival, FaPlaneDeparture, FaBed, FaDoorOpen } from 'react-icons/fa';
import { Layout, Globe, BarChart2, Mail, CreditCard, Users, ChevronDown, MoreHorizontal } from 'react-feather';
const Sidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = useTranslation();
  const [sidebarData, setSidebarData] = useState(SidebarData);
  const [isSideMenu, setIsSideMenu] = useState("booking-engine");
  const profileTabRef = useRef(null);
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const [moreMenuPosition, setMoreMenuPosition] = useState({ top: 0, left: 0 });
  const moreMenuRef = useRef(null);
  const moreDropdownRef = useRef(null);

  const toggleChatbot = (e) => {
    setIsChatbotOpen((prev) => !prev);
  };

  useEffect(() => {
    if (profileTabRef.current) {
      profileTabRef.current.click();
    }
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const clickedTrigger = moreMenuRef.current?.contains(event.target);
      const clickedDropdown = moreDropdownRef.current?.contains(event.target);

      if (!clickedTrigger && !clickedDropdown) {
        setIsMoreOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  useEffect(() => {
    setIsMoreOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!isMoreOpen) return undefined;

    const updateMoreMenuPosition = () => {
      const trigger = moreMenuRef.current;
      if (!trigger) return;

      const rect = trigger.getBoundingClientRect();
      const menuWidth = 278;
      const viewportPadding = 12;
      const preferredLeft = rect.right - menuWidth;
      const maxLeft = Math.max(viewportPadding, window.innerWidth - menuWidth - viewportPadding);

      setMoreMenuPosition({
        top: rect.bottom + 8,
        left: Math.min(Math.max(viewportPadding, preferredLeft), maxLeft),
      });
    };

    updateMoreMenuPosition();
    window.addEventListener("resize", updateMoreMenuPosition);
    window.addEventListener("scroll", updateMoreMenuPosition, true);

    return () => {
      window.removeEventListener("resize", updateMoreMenuPosition);
      window.removeEventListener("scroll", updateMoreMenuPosition, true);
    };
  }, [isMoreOpen]);

  useEffect(() => {
    const menuMapping = {
      '/hospitality': 'employee',
      '/departments': 'employee',
      '/designations': 'employee',
      '/profile': 'profile',
      '/leave-types': 'employee',
      '/holidays': 'employee',
      '/shift-list': 'employee',
      '/overtime': 'employee',
      '/announcements': 'employee',
      '/leaves-employee': 'leaves',
      '/adminleaves': 'leaves',
      '/leave-applications': 'leaves',
      '/leaves-balance': 'leaves',
      '/leave-settings': 'leaves',
      '/attendance-weekly': 'attendance',
      '/attendance-daily': 'attendance',
      '/adminattendance': 'attendance',
      '/attendance-employee': 'attendance',
      '/payroll-overview': 'payroll-overview',
      '/salary': 'payroll-overview',
      '/payroll-items': 'payroll-overview',
      '/run-payroll': 'payroll-overview',
      '/payroll-settings': 'payroll-overview',
      '/payroll-history': 'payroll-overview',
      '/payroll-reports': 'payroll-overview',
      '/devices': 'devices',
      '/deviceslog': 'devices',
      '/device-users': 'devices',
      '/manage-locations': 'company-settings',
      '/feedback/feedback-setting': 'feedback',
      '/feedback/feedback-responses': 'feedback',
      '/property-configuration': 'property-configuration',
    };

    const matchedMenu = Object.keys(menuMapping)
      .sort((a, b) => b.length - a.length)
      .find(route => pathname.startsWith(route)) || "";
    
    if (matchedMenu) {
      toggleSidebar(menuMapping[matchedMenu]);
    } else {
      toggleSidebar('feedback');
    }
  }, [pathname]);

  useEffect(() => {
    if (!isSideMenu) {
      toggleSidebar('employee-dashboard');
    }
  }, []);

  const expandSubMenus = (menu) => {
    const updatedAdminSidebar = sidebarData.map((section) => {
      const updatedSection = { ...section };
      updatedSection.menu = section.menu.map((menuItem) =>
        menu.menuValue !== menuItem.menuValue
          ? { ...menuItem, showSubRoute: false }
          : { ...menuItem, showSubRoute: true }
      );
      return updatedSection;
    });
    setSidebarData(updatedAdminSidebar);
  };

  const toggleSidebar = (value) => {
    setIsSideMenu(value);
  };

  const normalizedPath = pathname.replace(/\/+$/, "") || "/";

  const normalizeRoute = (route) =>
    String(route || "").replace(/\/+$/, "") || "/";

  // Keep Dashboard exact so it does not remain highlighted on child pages.
  const isActive = (routes) => {
    const routeArray = Array.isArray(routes) ? routes : [routes];
    return routeArray.some((route) => normalizedPath === normalizeRoute(route));
  };

  // Section-aware state keeps Booking Engine child pages anchored to the
  // correct operational module, matching the Channel Manager navigation model.
  const isSectionActive = (routes) => {
    const routeArray = Array.isArray(routes) ? routes : [routes];
    return routeArray.some((route) => {
      const base = normalizeRoute(route);
      return normalizedPath === base || normalizedPath.startsWith(`${base}/`);
    });
  };

  return (
    <>
      <div className="sidebar">
 
        <div className="sidebar-inner" >
          <div className="sidebar sidebar-twocol">
   
            <div className="sidebar-right"  style={{ 
        position: 'absolute', // or 'fixed' depending on desired behavior
        left: '0px', 
        width: "100%",
      }}
    >
              <div className="tab-content-horizontal" id="v-pills-tabContent">
                {isSideMenu === "dashboard" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li>
                          <Link
                            className={isActive(['/employee-dashboard']) ? "active" : ""}
                            to="/employee-dashboard"
                          >
                            <Home size={16} style={{ marginRight: '4px' }} /> {t("My Dashboard")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
  
   
{isSideMenu === "feedback" && (
<div className="tab-pane fade active show">
  {/*
    Keep the Channel Manager key-module card treatment, but suppress the
    generic submenu active underline for this one key item. This avoids the
    double active signal (outlined card + underline) without changing shared
    navigation CSS or affecting other modules.
  */}
  <style>{`
    .be-booking-topnav .cm-channel-nav-key > a.active::after {
      content: none !important;
      display: none !important;
    }
  `}</style>
  <nav
    className="submenu-horizontal cm-channel-topnav be-booking-topnav"
    aria-label="Booking Engine navigation"
  >
    <ul className="cm-channel-topnav-list">
      <li className="cm-channel-nav-item cm-channel-nav-primary">
        <Link
          className={isActive(["/booking-engine"]) ? "active" : ""}
          aria-current={isActive(["/booking-engine"]) ? "page" : undefined}
          to="/booking-engine"
          title="Booking Engine Dashboard"
        >
          <Home size={16} aria-hidden="true" />
          <span>{t("Dashboard")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-item cm-channel-nav-primary">
        <Link
          className={isSectionActive(["/booking-engine/bookings"]) ? "active" : ""}
          aria-current={isSectionActive(["/booking-engine/bookings"]) ? "page" : undefined}
          to="/booking-engine/bookings"
          title="Bookings"
        >
          <Calendar size={16} aria-hidden="true" />
          <span>{t("Bookings")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-item cm-channel-nav-primary cm-channel-nav-key">
        <Link
          className={isSectionActive(["/booking-engine/manual-inventory"]) ? "active" : ""}
          aria-current={isSectionActive(["/booking-engine/manual-inventory"]) ? "page" : undefined}
          to="/booking-engine/manual-inventory"
          title="Rates & Availability"
        >
          <TrendingUp size={16} aria-hidden="true" />
          <span>{t("Rates & Availability")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-item cm-channel-nav-primary">
        <Link
          className={isSectionActive(["/booking-engine/payment-setting"]) ? "active" : ""}
          aria-current={isSectionActive(["/booking-engine/payment-setting"]) ? "page" : undefined}
          to="/booking-engine/payment-setting"
          title="Payments"
        >
          <CreditCard size={16} aria-hidden="true" />
          <span>{t("Payments")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-item cm-channel-nav-primary">
        <Link
          className={isSectionActive(["/booking-engine/analytics"]) ? "active" : ""}
          aria-current={isSectionActive(["/booking-engine/analytics"]) ? "page" : undefined}
          to="/booking-engine/analytics"
          title="Analytics"
        >
          <BarChart2 size={16} aria-hidden="true" />
          <span>{t("Analytics")}</span>
        </Link>
      </li>

      <li className="cm-channel-nav-divider" aria-hidden="true" />

      <li className="cm-channel-nav-item cm-channel-nav-secondary">
        <Link
          className={isSectionActive([
            "/booking-engine/allocations",
            "/booking-engine/room-allocation",
          ]) ? "active" : ""}
          aria-current={isSectionActive([
            "/booking-engine/allocations",
            "/booking-engine/room-allocation",
          ]) ? "page" : undefined}
          to="/booking-engine/allocations"
          title="Integrations"
        >
          <Layers size={16} aria-hidden="true" />
          <span>{t("Integrations")}</span>
        </Link>
      </li>

      <li
        ref={moreMenuRef}
        className="cm-channel-nav-item cm-channel-nav-secondary"
        style={{ position: "relative" }}
      >
        <Link
          to="#"
          aria-haspopup="menu"
          aria-expanded={isMoreOpen}
          className={isSectionActive([
            "/booking-engine/booking-engine-config",
            "/booking-engine/layout",
            "/booking-engine/guests",
            "/booking-engine/refunds",
            "/booking-engine/reports",
            "/booking-engine/offers",
            "/booking-engine/promo-banners",
          ]) ? "active" : ""}
          onClick={(event) => {
            event.preventDefault();

            if (!isMoreOpen) {
              const rect = event.currentTarget.getBoundingClientRect();
              const menuWidth = 278;
              const viewportPadding = 12;
              const preferredLeft = rect.right - menuWidth;
              const maxLeft = Math.max(
                viewportPadding,
                window.innerWidth - menuWidth - viewportPadding
              );

              setMoreMenuPosition({
                top: rect.bottom + 8,
                left: Math.min(Math.max(viewportPadding, preferredLeft), maxLeft),
              });
            }

            setIsMoreOpen((open) => !open);
          }}
          title="Show More"
        >
          <MoreHorizontal size={16} aria-hidden="true" />
          <span>{t("Show More")}</span>
          <ChevronDown
            size={14}
            aria-hidden="true"
            style={{
              marginLeft: 3,
              transform: isMoreOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 160ms ease",
            }}
          />
        </Link>

        {isMoreOpen && typeof document !== "undefined" && createPortal(
          <div
            ref={moreDropdownRef}
            role="menu"
            aria-label={t("More Booking Engine tools")}
            style={{
              position: "fixed",
              top: moreMenuPosition.top,
              left: moreMenuPosition.left,
              zIndex: 9999,
              width: 278,
              padding: 8,
              background: "#ffffff",
              border: "1px solid #e7ebf0",
              borderRadius: 14,
              boxShadow: "0 18px 45px rgba(15, 23, 42, 0.14)",
            }}
          >
            <div
              style={{
                padding: "8px 10px 7px",
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: ".06em",
                textTransform: "uppercase",
                color: "#94a3b8",
              }}
            >
              {t("More Booking Engine tools")}
            </div>

            {[
              { route: "/booking-engine/booking-engine-config", label: "Property", Icon: MapPin },
              { route: "/booking-engine/layout", label: "Customize", Icon: Layout },
              { route: "/booking-engine/guests", label: "Guests", Icon: Users },
              { route: "/booking-engine/refunds", label: "Refunds", Icon: DollarSign },
              { route: "/booking-engine/offers", label: "Offers", Icon: Bell },
              { route: "/booking-engine/promo-banners", label: "Promo Banners", Icon: Bell },
            ].map(({ route, label, Icon }) => (
              <Link
                key={route}
                role="menuitem"
                className={isSectionActive([route]) ? "active" : ""}
                to={route}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  width: "100%",
                  minHeight: 40,
                  padding: "9px 10px",
                  borderRadius: 9,
                  whiteSpace: "nowrap",
                }}
              >
                <Icon size={15} />
                <span>{t(label)}</span>
              </Link>
            ))}

            <div style={{ height: 1, background: "#edf0f4", margin: "6px 4px" }} />

            <Link
              role="menuitem"
              className={isSectionActive([
                "/booking-engine/reports",
                "/booking-engine/reports/overview",
              ]) ? "active" : ""}
              to="#"
              onClick={(event) => event.preventDefault()}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                width: "100%",
                minHeight: 40,
                padding: "9px 10px",
                borderRadius: 9,
                whiteSpace: "nowrap",
              }}
            >
              <BarChart2 size={15} />
              <span>{t("Reports")}</span>
            </Link>
          </div>,
          document.body
        )}
      </li>
    </ul>
  </nav>
</div>
)}
                {isSideMenu === "settings" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li><Link to="/hospitality/property-configuration">{t("Account Settings")}</Link></li>
                        <li><Link to="/privacy-settings">{t("Privacy Settings")}</Link></li>
                        <li><Link to="/notification-settings">{t("Notification Settings")}</Link></li>
                        <li><Link to="/theme-settings">{t("Theme Settings")}</Link></li>
                      </ul>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
      <Chatbot isOpen={isChatbotOpen} toggleChatbot={toggleChatbot} />
    </>
  );
};

export default Sidebar;